import { Button, styled } from '@mui/material';

export const ContentW = styled('div')`
  width: 100%;
  max-width: 1106px;
  position: relative;

  @media (max-width: 1023px) {
    width: 100%;
    margin: 0px;
    padding: 0px;
  }

  @media (min-width: 1920px) {
    margin: 0 auto;
  }
`;

export const AddButtonW = styled(Button)`
  text-transform: none;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;
